module.exports = __webpack_public_path__ + "static/media/Aussenbaenke.0bf255b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Aussenbaenke.png
// module id = 118
// module chunks = 0